import { FilterValue } from "../Filters/FilterValue";
import { Vendor } from "../Vendors/Vendor";
import { PrintingType } from "./PrintingTypes";
import { ProductVariant } from "./ProductVariant";
import { UrgentSourcingProduct } from "./UrgentSourcingProductDetails";

export enum FilterProductsType {
  AllProducts = "all_products",
  FastProcurementProduct = "fast_procurement_product",
}

export const FILTER_PRODUCTS_TYPE_OPTIONS: FilterValue[] = [
  { id: FilterProductsType.AllProducts, value: "All" },
  {
    id: FilterProductsType.FastProcurementProduct,
    value: "Flash",
  },
];

export interface Product {
  id?: number;
  name?: string;
  seo_title?: string;
  seo_description?: string;
  category_id?: number;
  category_name?: string;
  active?: boolean;
  selling_price?: number;
  dimensions?: string;
  sizes?: string;
  capacity?: string;
  desc?: string;
  cost_price?: number;
  sku?: string;
  hsn_code?: string;
  colors?: string;
  fast_procurement?: boolean;
  display?: boolean;
  zoho_id?: string;
  image_url?: string;
  image_urls?: ProductImage[];
  vendors?: Vendor[];
  variants?: ProductVariant[];
  created_by?: number;
  creator_name?: string | null;
  last_modified_by?: number;
  modifier_name?: string | null;
  gst_percentage?: number;
  created_date?: string;
  modified_date?: string;
  categories?: ProductCategoriesMapping[];
  size_chart_url?: string;
  printing_types?: PrintingType[];
  preferred_printing_type_id?: number | null;
  preferred_vendor_id?: number | null;
  urgent_sourcing_details?: UrgentSourcingProduct[];
  /** POD membership SoT. */
  print_on_demand?: boolean | number;
  /** Deprecated alias of print_on_demand. */
  in_pod_catalog?: boolean;
  stock_by_city?: StockByCity[];
}

/** Prefer print_on_demand; fall back to legacy in_pod_catalog. */
export const isProductInPod = (
  product: Pick<Product, "print_on_demand" | "in_pod_catalog"> | null | undefined
): boolean => {
  if (!product) return false;
  if (product.print_on_demand !== undefined && product.print_on_demand !== null) {
    return Boolean(Number(product.print_on_demand));
  }
  return Boolean(product.in_pod_catalog);
};

export interface StockByCity {
  city: string;
  quantity: number;
}

export interface ProductImage {
  id?: number;
  url: string;
  creator_id?: number;
  creator_name?: string;
  is_default?: boolean;
  active?: boolean;
  modified_date?: Date;
  created_date?: Date;
}

export interface ProductCategoriesMapping {
  product_id?: number;
  category_id: number;
  category_name?: string;
  admin_id?: number;
  admin_name?: string;
  active?: boolean;
  modified_date?: Date;
  created_date?: Date;
}

export interface LastSoldProduct {
  product_id: number;
  rate?: number;
  date: Date;
}

export interface ProductSEODetails {
  id: number;
  seo_title: string;
  seo_description: string;
}
export interface ProductSourcingDetails {
  id: number;
  zoho_id?: string;
  hsn_code: string;
  printing_types?: PrintingType[];
  preferred_printing_type_id?: number | null;
  preferred_vendor_id?: number | null;
  gst_percentage: number;
  fast_procurement: boolean;
  vendors: Vendor[];
}
